
export default {
  'footer.platform': 'Platform',
  'footer.explore': 'Explore',
  'footer.how_it_works': 'How It Works',
  'footer.pricing': 'Pricing',
  'footer.security': 'Security',
  'footer.resources': 'Resources',
  'footer.blog': 'Blog',
  'footer.faq': 'FAQ',
  'footer.safety_tips': 'Safety Tips',
  'footer.support': 'Support',
  'footer.legal': 'Legal',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.cookies': 'Cookie Policy',
  'footer.content_policy': 'Content Policy',
  'footer.rights': 'All rights reserved',
  'footer.currency': 'Currency',
  'footer.about': 'About Us',
  'footer.contact': 'Contact Us',
  'footer.copyright': 'All rights reserved',
  'footer.language': 'Language',
};
